/*
 *
 * Session actions
 *
 */

import {
  VERIFY_SESSION,
  VERIFY_SESSION_SUCCESS,
  VERIFY_SESSION_ERROR,
  LOG_IN,
  LOG_IN_SUCCESS,
  LOG_IN_ERROR,
  LOG_OUT,
  LOG_OUT_SUCCESS,
  LOG_OUT_ERROR,
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_ERROR,
  OTP_APPROVE,
  OTP_APPROVE_SUCCESS,
  OTP_APPROVE_ERROR,
  // USER_ACCOUNT,
  // USER_ACCOUNT_SUCCESS,
  // USER_ACCOUNT_ERROR,
} from "./constants"

/**
 * @param {string} secret
 */
export function verifySession(secret) {
  return {
    type: VERIFY_SESSION,
    secret,
  }
}

/**
 * @param {object} user
 */
export function verifySessionSuccess(user) {
  return {
    type: VERIFY_SESSION_SUCCESS,
    user,
  }
}

/**
 * @param {string} error
 */
export function verifySessionError(error) {
  return {
    type: VERIFY_SESSION_ERROR,
    error,
  }
}

/**
 * @param {string} identifier
 * @param {string} secret
 * @param {object} queryParams
 * @param {string} form
 */
export function logIn(user, history, setSubmitting) {
  return {
    type: LOG_IN,
    user,
    history,
    setSubmitting,
  }
}

/**
 * @param {object} user
 * @param {string} token
 */
export function logInSuccess(user, token) {
  let timervalue = {
    running: false,
    value: 0,
  }
 
  localStorage.setItem("timer2", JSON.stringify(timervalue))
  return {
    type: LOG_IN_SUCCESS,
    user,
    token,
  }
}

// userAccount

// export function userAccount(userList) {
//   return {
//     type: USER_ACCOUNT,
//     userList,
//   };
// }

// export function userAccountSuccess(userList, success) {
//   return {
//     type: USER_ACCOUNT_SUCCESS,
//     userList,
//     success,
//   };
// }

// export function userAccountError(error) {
//   return {
//     type: USER_ACCOUNT_ERROR,
//     error,
//   };
// }

/**
 * @param {string} error
 */
export function logInError(error) {
  return {
    type: LOG_IN_ERROR,
    error,
  }
}

export function logOut(history) {
  return {
    type: LOG_OUT,
    history,
  }
}

export function logOutSuccess() {
  return {
    type: LOG_OUT_SUCCESS,
  }
}

/**
 * @param {string} error
 */
export function logOutError(error) {
  return {
    type: LOG_OUT_ERROR,
    error,
  }
}

/**
 * @param {object} record
 */
export function forgotPassword(record) {
  return {
    type: FORGOT_PASSWORD,
    record,
  }
}

/**
 * @param {string} success
 */
export function forgotPasswordSuccess(success) {
  return {
    type: FORGOT_PASSWORD_SUCCESS,
    success,
  }
}

/**
 * @param {string} error
 */
export function forgotPasswordError(error) {
  return {
    type: FORGOT_PASSWORD_ERROR,
    error,
  }
}

//RESET PASSWORD
export function resetPassword(reset_Password) {
  return {
    type: RESET_PASSWORD,
    reset_Password,
  }
}

/**
 * @param {string} success
 */
export function resetPasswordSuccess(reset_Password) {
  return {
    type: RESET_PASSWORD_SUCCESS,
    reset_Password,
  }
}

/**
 * @param {string} error
 */
export function resetPasswordError(error) {
  return {
    type: RESET_PASSWORD_ERROR,
    error,
  }
}

//OTP Approve
export function otpApprove(otp_approve) {
  return {
    type: OTP_APPROVE,
    otp_approve,
  }
}

/**
 * @param {string} success
 */
export function otpApproveSuccess(otp_approve) {
  return {
    type: OTP_APPROVE_SUCCESS,
    otp_approve,
  }
}

/**
 * @param {string} error
 */
export function otpApproveError(error) {
  return {
    type: OTP_APPROVE_ERROR,
    error,
  }
}

const actions = {
  verifySession,
  verifySessionSuccess,
  verifySessionError,
  logIn,
  logInSuccess,
  logInError,
  logOut,
  logOutSuccess,
  logOutError,
  forgotPassword,
  forgotPasswordSuccess,
  forgotPasswordError,
  resetPassword,
  resetPasswordSuccess,
  resetPasswordError,

  otpApprove,
  otpApproveSuccess,
  otpApproveError,
}

export default actions
